(function($) {
  var breakpoint = [544, 768, 1024, 1200, 1540, 2560, 4096];

  $.urlParam = function(name) {
    var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
      window.location.href
    );
    return results[1] || 0;
  };

  $.fn.cssNum = function() {
    return parseFloat($.fn.css.apply(this, arguments));
  };

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  $.fn.is_on_screen = function(offset) {
    //var offset = 50;
    var win = $(window);
    var viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width() - offset;
    viewport.bottom = viewport.top + win.height() - offset;

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(
      viewport.right < bounds.left ||
      viewport.left > bounds.right ||
      viewport.bottom < bounds.top ||
      viewport.top > bounds.bottom
    );
  };

  /**
   * Check if the resolution is mobile
   * @returns boolean
   */
  function isMobile() {
    return $(window).width() <= breakpoint[0];
  }

  /**
   * Check if the resolution is tab
   * @returns boolean
   */
  function isTab() {
    var w = $(window).width();
    return w > breakpoint[0] && w <= breakpoint[1];
  }

  /**
   * Check if the resolution is desk
   * returns boolean
   */
  function isDesk() {
    var w = $(window).width();
    return w > breakpoint[1] && w <= breakpoint[2];
  }

  /**
   * Check if the resolution is large
   * returns boolean
   */
  function isLarge() {
    var w = $(window).width();
    return w > breakpoint[2] && w <= breakpoint[3];
  }

  /**
   * Check if the resolution is big
   * returns boolean
   */
  function isBig() {
    var w = $(window).width();
    return w > breakpoint[3] && w <= breakpoint[4];
  }

  /**
   * Check if the resolution is huge
   * returns boolean
   */
  function isHuge() {
    var w = $(window).width();
    return w > breakpoint[4];
  }

  function lockBodyScroll(b = true) {
    if (b) {
      // prevent body from scrolling
      $('body').addClass('noScroll');
    }
    else {
      $('body').removeClass('noScroll');
    }
  }

  function mScrollTo(
    $target,
    offset = 0,
    duration,
    callback = () => {
      return false;
    }
  ) {
    $('html').animate(
      {
        scrollTop: $target.offset().top - offset
      },
      duration,
      function() {
        callback();
        console.debug('offset', offset);
        console.debug('scroll done');
      }
    );
  }

  function placeholder(doplaceholder = true) {
    console.debug('placeholder !!!');
    var $form = $(
      '#contact-message-feedback-form, .user-login-form, .commerce-checkout-flow'
    );
    $(
      '.js-form-type-textfield, .js-form-type-email, .js-form-type-password, .js-form-type-textarea, .js-form-type-select, .js-form-type-tel',
      $form
    ).each(function() {
      var label = $('label', $(this)).text();
      console.debug('label', label);
      $('input, textarea', $(this)).attr(
        'placeholder',
        doplaceholder ? label : ''
      );
    });
  }

  /**
   * Do things when sticky
   */
  function stickyThings() {
    var scrollPosition = $(window).scrollTop();
    var H = $(window).height();

    if (!isMobile() && !isTab()) {
      if (scrollPosition > H - 100 && scrollPosition < H) {
        $('.menu-main-wrapper').addClass(['sticky', 'transparent']);
        $('.damnes')
          .parent()
          .addClass(['sticky', 'transparent']);
      }
      else if (scrollPosition >= H) {
        $('.menu-main-wrapper').removeClass('transparent');
        $('.damnes')
          .parent()
          .removeClass('transparent');
      }
      else {
        $('.menu-main-wrapper').removeClass(['sticky', 'transparent']);
        $('.damnes')
          .parent()
          .removeClass(['sticky', 'transparent']);
      }
    }
  }

  var articles = [];
  Drupal.behaviors.enjoy = {
    attach: function(context, settings) {
      $('.logo-link', context).click(function(e) {
        e.preventDefault();
        if (isHome()) {
          mScrollTo($('#block-lesdamnesdelaterre-content'), 0, 1000);
        }
        else {
          location.href = '/';
        }
      });
      $('.menu-main-link, .menu-footer-link', context).click(function(e) {
        e.preventDefault();
        var $target = $($(this).attr('data-target'));
        if ($(this).hasClass('open')) {
          setTimeout(function() {
            lockBodyScroll();
          }, 500);

          $target.addClass('on');
        }
        else if ($(this).hasClass('scroll')) {
          var offset = $('.menu-main-wrapper').height();
          if (isHome()) {
            mScrollTo($target, offset, 1000, function() {
              setTimeout(function() {
                $('#burger').removeClass('headroom--unpinned');
                $('.menu-main-wrapper').removeClass('headroom--unpinned');
              }, 1200);
            });
          }
        }
        else {
          var url = $(this).attr('href');
          var target = $(this).attr('target');
          if (target == '_blank') {
            window.open(url, target);
          }
          else {
            window.location = url;
          }
        }
      });
      $('.cta-teasers', context).click(function(e) {
        e.preventDefault();
        mScrollTo($('.home-articles'), 0, 1000);
      });
      $('.cta-shop', context).click(function(e) {
        e.preventDefault();
        mScrollTo($('.home-shop'), 0, 1000);
      });
      $('.article-next', context).click(function(e) {
        e.preventDefault();
        artcilesNav(1);
      });
      $('.article-prev', context).click(function(e) {
        e.preventDefault();
        artcilesNav(-1);
      });
      $('.close', context).click(function(e) {
        e.preventDefault();
        $('.contact-block-wrapper').removeClass('on');
        lockBodyScroll(false);
      });
      $('.button--add-to-cart', context).click(function(e) {
        console.debug('add to cart ok.');
        setTimeout(function() {
          location.href = '/cart';
        }, 2000);
      });
      $('.article-readmore', context).click(function() {
        console.debug('readmore');
        $(this)
          .parent('.article-body')
          .removeClass('cropped');
      });
    },
    detach: function(context, settings) {}
  };

  function artcilesNav(next = 1) {
    var n = $('.row-article').length;
    var i = parseInt($('.row-article.on').attr('data-index'));
    var j = 0;
    switch (next) {
      case 1:
        j = (i + next) % n;
        console.debug('next', i, j, n);
        break;
      case -1:
        if (i == n) {
          i = 1;
          j = 0;
        }
        else if (i == 0) {
          j = n - 1;
        }
        else {
          j = i - 1;
        }
        console.debug('prev', i, j, n);
        break;
    }

    // Force views height
    $('.articles').css({ height: $('.articles').height() });

    var $row = $('.row-article[data-index=' + i + ']');
    var $next = $('.row-article[data-index=' + j + ']');

    $row.removeClass('visible');
    setTimeout(function() {
      $row.removeClass('on');
      $next.addClass('visible');
    }, 1000);

    $next.addClass('on');
  }

  /**
   * Inits slider
   * Uses slick library
   */
  function initSliderHome() {
    console.debug('slider home init');
    var $slick = $('.slider');

    $slick.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      arrows: false,
      dots: false,
      fade: true,
      lazyLoad: 'progressive',
      mobileFirst: true,
      adaptiveHeight: false
    });

    $(document).keydown(function(e) {
      if (e.keyCode == 37) {
        console.log('prev');
        $slick.slick('slickPrev');
        artcilesNav(-1);
        return false;
      }
      if (e.keyCode == 39) {
        console.log('next');
        $slick.slick('slickNext');
        artcilesNav(1);
        return false;
      }
    });
  }

  /**
   * Makes mobile menu
   */
  function mobileMenu() {
    var $mainMenu = $('.menu-main');
    var $burger = $('<div id="burger">burger</div>');
    var $wrapper = $(
      '<div id="mobile-menu-wrapper" class="mobile-menu-wrapper"></div>'
    );
    var $mobileMenu = $wrapper
      .prepend(
        $mainMenu
          .clone()
          .wrap('<div id="mobile-menu" class="mobile-menu"></div>')
          .parent()
      )
      .prepend($burger);
    $('body').prepend($mobileMenu);
    Drupal.attachBehaviors($mobileMenu);
    $('#burger').click(function() {
      lockBodyScroll(true);
      $('.mobile-menu').addClass('on');
    });
    $('#mobile-menu').click(function() {
      lockBodyScroll(false);
      $(this).removeClass('on');
    });
    $('#burger').headroom();
  }

  /**
   * Do things in html
   */
  function hackHTML() {
    console.debug('hack HTML');
    $('.row-article[data-index="0"]')
      .addClass('on')
      .addClass('visible');
    $('.main').css({
      'min-height':
        parseInt($(window).height()) -
        parseInt($('.header').outerHeight()) -
        parseInt($('.footer-wrapper').outerHeight())
    });
    if (isHome()) {
      if (isMobile() || isTab()) {
        $('.article-body').addClass('cropped');
      }
      else {
        $('.article-body')
          .addClass('scrollbar-macosx')
          .removeClass('cropped');
        $('.scrollbar-macosx').scrollbar();
      }
    }
    $('.article-right').each(function() {
      console.debug('article-right height', $(this).height());
      var $parent = $(this).parent('article-content');
      $('> .article-left', $parent).css('height', $(this).outerHeight());
    });

    // hack cart page
    if (isPath('/cart')) {
      var button = '<a href="/?anchor=buy" class="button">Ajouter un livre</a>';
      $('.form-actions.js-form-wrapper.form-wrapper').append(button);
    }

    // make video responsive
    if (isMobile() || isTab()) {
      $('.video').attr('width', '100%');
    }
    else if (isDesk() || isLarge()) {
      $('.video').attr('width', '75%');
    }
    else if (isBig()) {
      $('.video')
        .attr('width', '100%')
        .css({ margin: '5rem 0' });
    }

    placeholder();
  }

  /**
   * Check if path is home
   */
  function isHome() {
    return $('.node-type-home').length > 0;
  }

  /**
   * Check path
   */
  function isPath(path) {
    console.debug('path', window.location.pathname);
    return window.location.pathname == path;
  }

  /**
   * Do things when ready
   */
  function ready() {
    console.debug('ready');
    console.debug('mobile', isMobile());
    console.debug('tab', isTab());
    console.debug('desk', isDesk());
    console.debug('large', isLarge());
    console.debug('big', isBig());
    console.debug('huge', isHuge());

    if (isHome()) {
      initSliderHome();
      console.debug('urlParam', $.urlParam('anchor'));

      /*
      if ($.urlParam('anchor') === 'buy') {
        var offset = $('.menu-main-wrapper').height();
        var $target = $('.home-shop-anchor');
        mScrollTo($target, offset, 1000, function() {
          setTimeout(function() {
            $('#burger').removeClass('headroom--unpinned');
            $('.menu-main-wrapper').removeClass('headroom--unpinned');
          }, 1200);
        });
      }
      */
    }

    if (isMobile() || isTab()) {
      mobileMenu();
    }
    else {
      $('.menu-main-wrapper').headroom();
    }
  }

  /**
   * Do things at scrolling
   */
  var lastInViewport;
  function scroll() {
    stickyThings();

    $('.menu-main-item').each(function() {
      var target = $('.menu-main-link', this).attr('data-target');
      if (
        target !== lastInViewport &&
        $(target).is_on_screen(300) &&
        $(target).css('display') !== 'none'
      ) {
        console.debug('lastInViewport = ', target);
        lastInViewport = target;
        $('.menu-main-item').removeClass('on');
        $(this).addClass('on');
      }
    });

    return true;
  }

  /**
   * Do things when resized
   * @return {boolean} true
   */
  function resize() {
    console.debug('resize');
    return true;
  }

  /**
   * Do things when loaded
   * @returns {boolean} true
   */
  function loaded() {
    console.debug('loaded');
    setTimeout(function() {
      hackHTML();
    }, 50);
    return true;
  }

  $(window).ready(ready);
  $(window).scroll(scroll);
  $(window).resize(resize);
  $(window).on(
    'load',
    {
      passive: true
    },
    function(e) {
      loaded();
    }
  );
})(jQuery);
